import { useQuery } from '@tanstack/react-query'

import { CAR_QUERY_KEYS, VEHICLE_TYPE } from '@/entities/car/lib'
import { ICarBrand } from '@/entities/car/model'

import { getCarBrandList } from '../request/carApis'

const useCarBrandListQuery = () => {
  return useQuery<ICarBrand[]>({
    queryKey: CAR_QUERY_KEYS.CAR_BRAND.list(),
    queryFn: () =>
      getCarBrandList({
        params: {
          vehicleType: VEHICLE_TYPE.CAR,
        },
      }),
    select: data =>
      data.map(brand => ({
        ...brand,
        name:
          brand.name === '쉐보레(GM대우)'
            ? ('쉐보레(국내)' as typeof brand.name)
            : brand.name,
      })),
    throwOnError: false,
  })
}

export default useCarBrandListQuery
